import Seo from "@/components/Seo";
import { SITE } from "@/data/site";

const SECTIONS = [
  {
    title: "Who We Are",
    body: "Travel Passport and Visa LLC is a private courier and travel document assistance company. It is not a government agency and is not affiliated with, endorsed by, or sponsored by the U.S. Department of State or any other government entity. You may always apply directly through the U.S. Department of State or the applicable embassy or consulate, paying only the government fees.",
  },
  {
    title: "Our Services",
    body: "We provide professional assistance with passport, visa, and travel document preparation, including requirement research, document organization, application review, and process guidance. Our services are administrative and advisory in nature.",
  },
  {
    title: "No Guaranteed Outcomes",
    body: "Government agencies and consulates control all eligibility, processing, appointment, and approval decisions. We do not guarantee passport or visa approval, appointments, or processing by any specific date. Processing times discussed are estimates only, are subject to change, and cannot be guaranteed.",
  },
  {
    title: "Fees",
    body: "Mandatory government fees are set by the U.S. Department of State or the applicable consulate, are paid to the government, and are in addition to our service fees. Our professional service fees are charged separately and are explained before work begins.",
  },
  {
    title: "Accuracy of Information",
    body: "Requirements, fees, and processing conditions set by government agencies and consulates change frequently. While we work to keep our guidance current, the applicable government agency or consulate is always the final authority on its own requirements.",
  },
  {
    title: "Limitation of Liability",
    body: "To the fullest extent permitted by law, Travel Passport and Visa LLC is not liable for decisions made by government agencies or consulates, including application denials, processing delays, appointment availability, or changes to government requirements or fees.",
  },
  {
    title: "Contact",
    body: "Questions about these Terms may be directed to our team at 866-334-8472 or at 1629 K St NW, Suite 305, Washington, DC 20006.",
  },
];

export default function TermsPage() {
  return (
    <>
      <Seo
        title="Terms of Service | Travel Passport and Visa LLC"
        siteName={SITE.siteName}
        description="Terms of Service for Travel Passport and Visa LLC — a private passport, visa, and travel document assistance company in Washington, DC."
      />
      <section className="grain bg-navy py-16" data-testid="terms-hero">
        <div className="mx-auto max-w-7xl px-4 sm:px-6">
          <h1 className="font-display text-4xl font-bold tracking-tight text-white sm:text-5xl" data-testid="terms-h1">
            Terms of Service
          </h1>
          <p className="mt-4 text-sm text-slate-400">{SITE.name} — Washington, DC</p>
        </div>
      </section>
      <section className="bg-white py-16">
        <div className="mx-auto max-w-3xl space-y-10 px-4 sm:px-6" data-testid="terms-content">
          {SECTIONS.map((s) => (
            <div key={s.title}>
              <h2 className="font-display text-xl font-bold text-navy">{s.title}</h2>
              <p className="mt-3 text-sm leading-relaxed text-slate-600">{s.body}</p>
            </div>
          ))}
          <div className="rounded-xl border-l-4 border-gold bg-slate-50 p-6">
            <p className="text-sm leading-relaxed text-slate-600">{SITE.disclosure}</p>
          </div>
        </div>
      </section>
    </>
  );
}
